import React from "react"

// There is already a viewport definition in src/html.tsx
const Viewport: React.FC = () => null

export default Viewport
